import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgProgress } from '@ngx-progressbar/core';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { ToastrService } from 'ngx-toastr';
import { Observable, forkJoin } from 'rxjs';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { ConfirmationComponent } from '../../../../shared/components/confirmation/confirmation.component';
import { matchExternalSSO } from '../../../../shared/constants/external-sso.constants';
import { ConfirmationModel } from '../../../../shared/model/confirmation.model';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { SEARCH_QUITE_PERIOD } from '../../../../shared/utils/miscellaneous.utils';
import { AuthService } from '../../../security/service/auth.service';
import {
  CustomerModel,
  GroupModel,
  PersonaModel,
  ServiceProviderModel
} from '../../../user/model/user.model';
import { UsersService } from '../../../user/service/users.service';

@Component({
  selector: 'sp-new-user',
  templateUrl:
    './console/app-js/modules/spUser/components/sp-new-user/sp-new-user.component.html'
})
export class SpNewUserComponent extends APIOperableComponent implements OnInit {
  public static SERVICEPROVIDERGROUP = 'Service Provider';
  public static SERVICEPROVIDERMOBILEGROUP = 'Service Provider Mobile';
  public static SERVICEPROVIDERCONTROLLERGROUP = 'Service Provider Controller';
  public static USERMANAGEMENTADMINISTRATORGROUP =
    'User Management Administrator';
  public static SERVICEPROVIDERFINANCIALGROUP: string =
    'Service Provider Financial';
  public static REPORTVIEWERGROUP: string = 'Report Viewer';

  public groupsToFind = [
    SpNewUserComponent.SERVICEPROVIDERGROUP,
    SpNewUserComponent.SERVICEPROVIDERMOBILEGROUP,
    SpNewUserComponent.SERVICEPROVIDERCONTROLLERGROUP,
    SpNewUserComponent.USERMANAGEMENTADMINISTRATORGROUP,
    SpNewUserComponent.SERVICEPROVIDERFINANCIALGROUP,
    SpNewUserComponent.REPORTVIEWERGROUP
  ];

  public static SERVICEPROVIDERADD = 'Add User';
  public static SERVICEPROVIDEREDIT = 'Edit User';

  public groupLookup: Map<string, any> = new Map<string, any>();
  isMobileTechnician: boolean = false;
  isController: boolean = false;
  isUserManagementAdministrator: boolean = false;
  isFinancial: boolean = false;
  isReportViewer: boolean = false;
  isMobileTechnicianAdded: boolean = false;
  isControllerAdded: boolean = false;
  isUserManagementAdministratorAdded: boolean = false;
  public typingTimeout: any;
  isFinancialAdded: boolean = false;
  isReportViewerAdded: boolean = false;
  public pageSize: number = 100;
  public pageNumber: number = 0;

  @Input('opened') opened = false;
  @Input('title') title = SpNewUserComponent.SERVICEPROVIDEREDIT;
  @Input('user') spUser: any;
  @Input('serviceProvidersList') serviceProvidersList: any;
  @Input('serviceProvidersListAll') serviceProvidersListAll: any;
  @Input('isLoadProvidersAll') isLoadProvidersAll: boolean;
  @Output() closed = new EventEmitter<any>();
  @ViewChild('templateForm', { static: true }) templateForm: NgForm;
  @ViewChildren('kendoMultiSelectInstance')
  protected kendoMultiSelectInstances: Array<MultiSelectComponent>;
  protected originalData: Array<any> = [];
  protected temporaryData: Array<any> = [];
  protected groupList: Array<any> = [];
  protected groupsSelected: Array<any> = [];
  protected tempGroupsSelected: Array<any> = [];
  protected personaSelected: any;
  public isValidEmail = true;
  public emailTooLong = false;
  protected selectedSites: any;
  protected sitesList: Array<any> = [];
  protected originalSitesData: Array<any> = [];
  protected sitesLoadingIndicator: boolean;
  protected selectedCustomers: any;
  protected customersList: Array<any> = [];
  protected originalCustomersData: Array<any> = [];
  protected customersLoadingIndicator: boolean;
  protected personasList: Array<PersonaModel>;
  protected groupsOnly: Array<GroupModel>;
  protected originalSPsData: Array<any> = [];
  protected selectedProviders: any;
  protected initialGroup: any;
  protected personaName: string;
  protected firstNameDisabled: boolean;
  protected lastNameDisabled: boolean;
  protected emailDisabled: boolean = false;
  protected roleDisabled: boolean;
  protected providerAccessDisabled: boolean;
  public isEnterpriseSP: boolean;
  private hasChanges: boolean;
  public data: any;
  public isMultipleServiceProviderAccess: boolean;
  public isVixxoEmail: boolean;
  public filterGridData: any;
  public selectableSettings: SelectableSettings = {
    enabled: true,
    mode: 'multiple',
    checkboxOnly: true
  };
  public selectedAccessProviderNumber: any[] = [];
  public selectedSPAccessNumber: any;
  public spAccessNumber: any;
  public isFormValid: Boolean = false;
  public dataSP = [];
  public spDataLoadLength = 100;
  public countSP = 0;
  public searchQuery: string = '';
  public allGroupsList: any = [];
  public user: any;
  public sortedSPList: any;
  public isSPGridLoading: Boolean = true;
  public statusSwitch: boolean;
  public statusDeactivated: boolean;
  public statusActive: string;
  public isAuth0EmailExists = false;
  public federatedSSOMatch: boolean = false;
  public sortedSPListAll: any;
  private pendingDuplicateRolesSnapshot: {
    isMobileTechnician: boolean;
    isController: boolean;
    isUserManagementAdministrator: boolean;
    isFinancial: boolean;
    isReportViewer: boolean;
  } | null = null;

  constructor(
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private usersService: UsersService,
    private dialogService: UIDialogService
  ) {
    super(progressService, toastr, authService);
  }

  ngOnInit() {
    this.user = { ...this.spUser };
    this.personaSelected = {};
    if (this.authService.isEnterpriseSPUserManager()) {
      this.isEnterpriseSP = true;
      this.personaSelected.persona = 'Service Provider';
    } else {
      this.isEnterpriseSP = false;
    }

    this.usersService.getGroups().subscribe((results: any) => {
      results.groups &&
        results.groups.forEach((group: any) => {
          this.allGroupsList.push(group);
        });

      this.allGroupsList.forEach((group: any) => {
        if (this.groupsToFind.indexOf(group.name) > -1) {
          this.groupLookup.set(group.name, group);
        }
      });
    });

    if (this.user.isEdit) {
      this.emailDisabled = true;
      this.loadingIndicator = true;
      this.selectedAccessProviderNumber = this.user.serviceProviderNumbers;
      this.selectedSPAccessNumber = this.selectedAccessProviderNumber;

      if (this.user.status && this.user.status === 'Active') {
        this.statusSwitch = true;
        this.statusActive = this.user.status;
        this.enableEditFields();
      } else {
        this.statusSwitch = false;
        this.statusActive = this.user.status;
        this.disableEditFields();
      }
      this.usersService.getUserInfo(this.user).subscribe((res: any) => {
        res.groups &&
          res.groups.forEach((group: any) => {
            if (group.name === SpNewUserComponent.SERVICEPROVIDERMOBILEGROUP) {
              this.isMobileTechnician = this.isMobileTechnicianAdded = true;
            }
            if (
              group.name === SpNewUserComponent.SERVICEPROVIDERCONTROLLERGROUP
            ) {
              this.isController = this.isControllerAdded = true;
            }
            if (
              group.name === SpNewUserComponent.USERMANAGEMENTADMINISTRATORGROUP
            ) {
              this.isUserManagementAdministrator = this.isUserManagementAdministratorAdded = true;
            }
            if (
              group.name === SpNewUserComponent.SERVICEPROVIDERFINANCIALGROUP
            ) {
              this.isFinancial = this.isFinancialAdded = true;
            }
            if (group.name === SpNewUserComponent.REPORTVIEWERGROUP) {
              this.isReportViewer = this.isReportViewerAdded = true;
            }
          });
        this.loadingIndicator = false;
      });
      this.checkVixxoEmail(this.user.email);
      this.updateChanges();
    }
  }

  ngDoCheck() {
    if (
      this.serviceProvidersList &&
      this.serviceProvidersList.length > 0 &&
      this.isSPGridLoading &&
      this.pageNumber == 0
    ) {
      this.isSPGridLoading = false;
      this.sortedServiceProviderList();
      this.sortedServiceProviderListAll();
      this.filterSP();
    }
    if (
      this.serviceProvidersListAll &&
      this.serviceProvidersListAll.length > 0
    ) {
      this.sortedServiceProviderListAll();
    }
  }

  loadMore() {
    this.countSP = this.countSP + this.pageSize;
    this.pageNumber = this.pageNumber + 1;
    this.filterSP();
  }

  searchSP(searchInput: string) {
    this.searchQuery = searchInput ? searchInput : '';
    this.countSP = 0;
    this.pageNumber = 1;
    this.dataSP = [];
    clearTimeout(this.typingTimeout);
    this.typingTimeout = setTimeout(() => this.filterSP(), SEARCH_QUITE_PERIOD);
  }

  filterSP() {
    let data = [...this.sortedSPList];
    if (this.pageNumber > 0) {
      this.isSPGridLoading = true;
      this.usersService
        .getServiceProvidersWithPaging(
          this.pageNumber,
          this.pageSize,
          this.searchQuery
        )
        .subscribe(result => {
          if (result && result.results) {
            let uniqueSpNumbers: any = [];
            result.results.forEach((item, i) => {
              if (
                this.selectedSPAccessNumber &&
                item.number &&
                !this.selectedSPAccessNumber.includes(item.number) &&
                !uniqueSpNumbers.includes(item.number)
              ) {
                uniqueSpNumbers.push(item);
              }
            });

            result.results =
              uniqueSpNumbers.length > 0 ? uniqueSpNumbers : result.results;

            let pagingdata = result.results.map(e => {
              return { text: e.number };
            });

            if (this.pageNumber == 1) {
              this.dataSP = [];
              if (
                this.selectedSPAccessNumber &&
                this.selectedSPAccessNumber.length > 0
              ) {
                let selectedSPNumberList = this.selectedSPAccessNumber.map(
                  e => {
                    return { text: e };
                  }
                );
                selectedSPNumberList.forEach(e => {
                  pagingdata.unshift(e);
                });
              }
            }

            data = pagingdata;
            this.dataSP =
              this.dataSP.length > 0 ? [...this.dataSP, ...data] : data;
            this.isSPGridLoading = false;
          }
        });
    } else {
      let uniqueSpNumbers: any = [];

      data.forEach((item, i) => {
        if (
          this.selectedSPAccessNumber &&
          !this.selectedSPAccessNumber.includes(item.text) &&
          !uniqueSpNumbers.includes(item.text)
        ) {
          uniqueSpNumbers.push(item);
        }
      });

      this.dataSP = uniqueSpNumbers.length > 0 ? uniqueSpNumbers : data;

      if (
        this.selectedSPAccessNumber &&
        this.selectedSPAccessNumber.length > 0
      ) {
        let selectedSPNumberList = this.selectedSPAccessNumber.map(e => {
          return { text: e };
        });
        selectedSPNumberList.forEach(e => {
          this.dataSP.unshift(e);
        });
      }
    }
  }

  sortedServiceProviderListAll() {
    if (this.isLoadProvidersAll) {
      this.sortedSPListAll = [...this.serviceProvidersListAll];
      if (!this.user.serviceProviderNumbers) {
        return;
      }
      if (this.serviceProvidersListAll.length > 0) {
        this.sortedSPListAll.forEach((item, i) => {
          if (this.user.serviceProviderNumbers.includes(item.text)) {
            this.sortedSPListAll.splice(i, 1);
            this.sortedSPListAll.unshift(item);
          }
        });
      }
    }
  }

  sortedServiceProviderList() {
    this.sortedSPList = [...this.serviceProvidersList];
    if (!this.user.serviceProviderNumbers) {
      return;
    }
    this.sortedSPList.forEach((item, i) => {
      if (this.user.serviceProviderNumbers.includes(item.text)) {
        this.sortedSPList.splice(i, 1);
        this.sortedSPList.unshift(item);
      }
    });
  }

  private enableEditFields() {
    this.firstNameDisabled = false;
    this.lastNameDisabled = false;
    this.roleDisabled = false;
    this.providerAccessDisabled = false;
    this.user.isEdit
      ? (this.emailDisabled = true)
      : (this.emailDisabled = false);
  }

  private disableEditFields() {
    this.firstNameDisabled = true;
    this.lastNameDisabled = true;
    this.emailDisabled = true;
    this.roleDisabled = true;
    this.providerAccessDisabled = true;
  }

  // Set sp mobile technician flag for keymaster api call
  public onMobileTechnicianValueChange(event: any) {
    this.isMobileTechnician = <boolean>event.target.checked;
  }

  public onControllerChange(event: any) {
    this.isController = <boolean>event.target.checked;
  }

  public onUserManagementValueChange(event: any) {
    this.isUserManagementAdministrator = <boolean>event.target.checked;
  }

  public onFinancialValueChange(event: any) {
    this.isFinancial = <boolean>event.target.checked;
  }

  public onReportViewerValueChange(event: any) {
    this.isReportViewer = <boolean>event.target.checked;
  }

  public onSelectedAccessProviderChange(selectedValue: any) {
    this.selectedAccessProviderNumber = this.spAccessNumber = [];
    this.spAccessNumber.push(selectedValue);
    this.selectedAccessProviderNumber = this.spAccessNumber[0];
  }

  public close(isActionPerformed: boolean): void {
    this.closed.emit({ isActionPerformed: isActionPerformed });
    this.opened = false;
  }

  /**
   * Update hasChanges Boolean
   */
  changesMade(): boolean {
    return (
      this.templateForm.controls.email.dirty ||
      this.templateForm.controls.firstName.dirty ||
      this.templateForm.controls.lastName.dirty ||
      this.hasChanges
    );
  }

  updateChanges() {
    this.hasChanges = true;
  }

  onValueChangePersonaList($event) {
    this.hasChanges = true;
    this.groupsOnly = this.originalData.filter(
      specificGrp =>
        specificGrp.persona === $event.persona && specificGrp.type === 'group'
    );
    this.groupList = this.groupsOnly;
    this.initialGroup = [];
    this.initialGroup = this.personasList.filter(
      pGroup => pGroup.persona === $event.persona
    );

    if (this.title === SpNewUserComponent.SERVICEPROVIDERADD) {
      // initialise personaSelected
      this.personaSelected = '';
      this.personaSelected = $event;
      // initialize metadata
      this.user.metadata.customer = new CustomerModel();
      this.user.metadata.serviceProvider = new ServiceProviderModel();
      this.initialGroup = this.initialGroup[0];
      this.groupsSelected = [];
    } else {
      if (!this.user.metadata.serviceProvider) {
        this.user.metadata.serviceProvider = new ServiceProviderModel();
      }

      if (!this.user.metadata.customer) {
        this.user.metadata.customer = new CustomerModel();
      }
      // bind original data when changed to its original persona
      if (this.personaName === $event.persona) {
        this.groupsSelected = this.tempGroupsSelected;
        if (
          this.selectedProviders &&
          this.selectedProviders.serviceProviderNumbers &&
          this.selectedProviders.serviceProviderNumbers.length > 0
        ) {
          this.user.metadata.serviceProvider = this.selectedProviders;
        }
        if (this.selectedCustomers) {
          this.user.metadata.customer = this.selectedCustomers;
        }
      } else {
        this.groupsSelected = [];
        this.user.metadata.serviceProvider = new ServiceProviderModel();
        this.user.metadata.customer = new CustomerModel();
      }
    }

    // reset form element: groups to pristine state
    if (this.templateForm.controls && this.templateForm.controls.groups) {
      this.templateForm.controls.groups.markAsPristine();
      this.templateForm.controls.groups.markAsUntouched();
    }
  }

  /**
   * On Save button click.
   */
  onSave(): void {
    if (this.title === SpNewUserComponent.SERVICEPROVIDEREDIT) {
      this.editUser(this.user);
    } else {
      this.createUser(
        this.user,
        this.isMobileTechnician,
        this.isController,
        this.isUserManagementAdministrator,
        this.isFinancial,
        this.isReportViewer
      );
    }
  }

  /**
   * Perform the add and remove operations if detected on user selections.
   * @param newGroups
   * @param user
   */
  private createUser(
    user: any,
    isMobileTechnician: boolean,
    isController: boolean,
    isUserManagementAdministrator: boolean,
    isFinancial: boolean,
    isReportViewer: boolean
  ): void {
    this.startProgress();
    user.serviceProviderNumbers = this.selectedAccessProviderNumber;
    this.pendingDuplicateRolesSnapshot = {
      isMobileTechnician,
      isController,
      isUserManagementAdministrator,
      isFinancial,
      isReportViewer
    };
    this.submitCreateServiceProvider(user, false);
  }

  private submitCreateServiceProvider(
    user: any,
    enableExistingRegisteredUser: boolean
  ): void {
    this.usersService
      .createServiceProvider(user, enableExistingRegisteredUser)
      .subscribe(
        result => {
          user.id = result.id;
        },
        (errorResponse: any) => {
          const errorBody =
            errorResponse && errorResponse.error
              ? errorResponse.error
              : errorResponse;
          if (
            !enableExistingRegisteredUser &&
            errorBody &&
            errorBody.duplicate
          ) {
            this.promptEnableExistingUser(user);
            return;
          }
          this.pendingDuplicateRolesSnapshot = null;
          this.onAPIError(
            errorBody && errorBody.message
              ? errorBody.message
              : 'An error occurred while creating the user.'
          );
        },
        () => {
          this.addGroupsAfterCreate(user);
        }
      );
  }

  private addGroupsAfterCreate(user: any): void {
    const roles = this.pendingDuplicateRolesSnapshot;
    let groupsToAdd: Array<any> = [];

    groupsToAdd.push(
      this.groupLookup.get(SpNewUserComponent.SERVICEPROVIDERGROUP)
    );

    if (roles && roles.isMobileTechnician) {
      groupsToAdd.push(
        this.groupLookup.get(SpNewUserComponent.SERVICEPROVIDERMOBILEGROUP)
      );
    }

    if (roles && roles.isController) {
      groupsToAdd.push(
        this.groupLookup.get(SpNewUserComponent.SERVICEPROVIDERCONTROLLERGROUP)
      );
    }

    if (roles && roles.isUserManagementAdministrator) {
      groupsToAdd.push(
        this.groupLookup.get(
          SpNewUserComponent.USERMANAGEMENTADMINISTRATORGROUP
        )
      );
    }

    if (roles && roles.isFinancial) {
      groupsToAdd.push(
        this.groupLookup.get(SpNewUserComponent.SERVICEPROVIDERFINANCIALGROUP)
      );
    }

    if (roles && roles.isReportViewer) {
      groupsToAdd.push(
        this.groupLookup.get(SpNewUserComponent.REPORTVIEWERGROUP)
      );
    }

    let assignedGroups: Array<any> = [];
    groupsToAdd.forEach((serviceProvider: any) => {
      if (serviceProvider) {
        let spGroupObject: any = {};
        spGroupObject['userId'] = user.id;
        spGroupObject['groupId'] = serviceProvider.id;
        assignedGroups.push(spGroupObject);
      }
    });

    this.usersService
      .addGroups(assignedGroups.map(item => item.groupId), user.id)
      .subscribe(
        () => {
          this.pendingDuplicateRolesSnapshot = null;
          this.onAPISuccess('User Created successfully');
          this.close(true);
        },
        () => {
          this.pendingDuplicateRolesSnapshot = null;
          this.onAPIError('An error occurred while adding User Groups');
        }
      );
  }

  private promptEnableExistingUser(user: any): void {
    this.finishProgress();
    this.dialogService
      .open(ConfirmationComponent, [
        {
          provide: ConfirmationModel,
          useValue: new ConfirmationModel(
            'Existing User',
            'User already registered. Enable this user?'
          )
        }
      ])
      .then(confirmed => {
        if (confirmed) {
          this.startProgress();
          this.submitCreateServiceProvider(user, true);
        } else {
          this.pendingDuplicateRolesSnapshot = null;
          this.toastr.info('No changes were made to the existing user.');
          this.close(false);
        }
      });
  }

  /**
   * Perform the add and remove operations if detected on user selections.
   * @param newGroups
   * @param removedGroups
   * @param user
   */
  private editUser(user: any): void {
    this.loadingIndicator = true;
    this.startProgress();
    let apiCalls: Array<Observable<any>> = [];
    let operationResults: Array<any> = [null, null, null];
    let isSuccess = false;
    user.serviceProviderNumbers = this.selectedAccessProviderNumber;

    let groupsToAdd: Array<any> = [];
    let groupsToRemove: Array<any> = [];

    groupsToAdd.push(
      this.groupLookup.get(SpNewUserComponent.SERVICEPROVIDERGROUP)
    );

    if (this.isMobileTechnician && !this.isMobileTechnicianAdded) {
      groupsToAdd.push(
        this.groupLookup.get(SpNewUserComponent.SERVICEPROVIDERMOBILEGROUP)
      );
    }

    if (this.isController && !this.isControllerAdded) {
      groupsToAdd.push(
        this.groupLookup.get(SpNewUserComponent.SERVICEPROVIDERCONTROLLERGROUP)
      );
    }

    if (
      this.isUserManagementAdministrator &&
      !this.isUserManagementAdministratorAdded
    ) {
      groupsToAdd.push(
        this.groupLookup.get(
          SpNewUserComponent.USERMANAGEMENTADMINISTRATORGROUP
        )
      );
    }

    if (this.isFinancial && !this.isFinancialAdded) {
      groupsToAdd.push(
        this.groupLookup.get(SpNewUserComponent.SERVICEPROVIDERFINANCIALGROUP)
      );
    }

    if (this.isReportViewer && !this.isReportViewerAdded) {
      groupsToAdd.push(
        this.groupLookup.get(SpNewUserComponent.REPORTVIEWERGROUP)
      );
    }

    let assignedGroups: Array<any> = [];
    groupsToAdd.forEach((serviceProvider: any) => {
      let spGroupObject: any = {};
      spGroupObject['userId'] = user.id;
      spGroupObject['groupId'] = serviceProvider.id;
      assignedGroups.push(spGroupObject);
    });

    if (assignedGroups.length > 0) {
      apiCalls.push(
        this.usersService.addGroups(
          assignedGroups.map(item => item.groupId),
          user.id
        )
      );
    }

    if (!this.isMobileTechnician && this.isMobileTechnicianAdded) {
      groupsToRemove.push(
        this.groupLookup.get(SpNewUserComponent.SERVICEPROVIDERMOBILEGROUP)
      );
    }

    if (!this.isController && this.isControllerAdded) {
      groupsToRemove.push(
        this.groupLookup.get(SpNewUserComponent.SERVICEPROVIDERCONTROLLERGROUP)
      );
    }

    if (
      !this.isUserManagementAdministrator &&
      this.isUserManagementAdministratorAdded
    ) {
      groupsToRemove.push(
        this.groupLookup.get(
          SpNewUserComponent.USERMANAGEMENTADMINISTRATORGROUP
        )
      );
    }

    if (!this.isFinancial && this.isFinancialAdded) {
      groupsToRemove.push(
        this.groupLookup.get(SpNewUserComponent.SERVICEPROVIDERFINANCIALGROUP)
      );
    }

    if (!this.isReportViewer && this.isReportViewerAdded) {
      groupsToRemove.push(
        this.groupLookup.get(SpNewUserComponent.REPORTVIEWERGROUP)
      );
    }

    let removedGroups: Array<any> = [];
    groupsToRemove.forEach((serviceProvider: any) => {
      let spGroupObject: any = {};
      spGroupObject['userId'] = user.id;
      spGroupObject['groupId'] = serviceProvider.id;
      removedGroups.push(spGroupObject);
    });

    if (removedGroups.length > 0) {
      apiCalls.push(
        this.usersService.deleteGroups(
          removedGroups.map(item => item.groupId),
          user.id
        )
      );
    }

    apiCalls.push(this.usersService.updateServiceProvider(user));
    apiCalls.push(this.usersService.updateUserAccountStatus(user));

    const observables = forkJoin<any>(apiCalls);
    observables.subscribe({
      next: results => {
        if (results.length === 3) {
          operationResults = results.map((item: any) => item.success);
        } else {
          operationResults[2] = results[0];
        }
      },
      complete: () => {
        this.onAPISuccess('User has been successfully updated');
        isSuccess = true;
        this.loadingIndicator = false;
        this.finishProgress();
        this.close(isSuccess);
      }
    });
    this.loadingIndicator = false;
  }

  /**
   * On Cancel/Close button event.
   */
  onCancelClose(): void {
    this.close(false);
  }

  /**
   * Validate FirstName
   */
  firstNameValidation(): boolean {
    return (
      this.templateForm.controls.firstName &&
      this.templateForm.controls.firstName.errors &&
      (this.templateForm.controls.firstName.dirty ||
        this.templateForm.controls.firstName.touched)
    );
  }

  /**
   * Validate LastName
   */
  lastNameValidation(): boolean {
    return (
      this.templateForm.controls.lastName &&
      this.templateForm.controls.lastName.errors &&
      (this.templateForm.controls.lastName.dirty ||
        this.templateForm.controls.lastName.touched)
    );
  }

  /**
   * Validate Email
   */
  emailValidation(): boolean {
    return (
      this.templateForm.controls.email &&
      this.templateForm.controls.email.errors &&
      (this.templateForm.controls.email.dirty ||
        this.templateForm.controls.email.touched)
    );
  }

  /**
   * Validate no special characters or numbers
   */
  specialCharCheck(name: string): boolean {
    if (name) {
      return !/^[A-Za-z]+$/.test(name);
    } else {
      return false;
    }
  }

  /**
   * Validate group present for Add user
   */
  groupCheck(): boolean {
    return (
      this.personaSelected &&
      this.personaSelected.persona === 'Admin Portal' &&
      (this.groupsSelected === undefined || this.groupsSelected.length === 0)
    );
  }

  resetButtonVisibilityCheck(): boolean {
    if (this.title === SpNewUserComponent.SERVICEPROVIDEREDIT) {
      if (
        this.authService.isUsersManagerAdmin() ||
        this.authService.isEnterpriseSPUserManager()
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /**
   * Validate persona present for User
   */
  personaCheck(): boolean {
    return this.personaSelected === undefined || !this.personaSelected.persona;
  }

  /**
   * Validate The User Can Save
   */
  saveDisabled(): boolean {
    return (
      !this.user.firstName ||
      !this.user.lastName ||
      !this.user.email ||
      (this.isVixxoEmail &&
        this.templateForm.controls.email &&
        this.templateForm.controls.email.dirty) ||
      !(this.selectedAccessProviderNumber.length > 0) ||
      (!this.isValidEmail &&
        this.templateForm.controls.email &&
        this.templateForm.controls.email.dirty) ||
      this.emailTooLong ||
      this.isAuth0EmailExists ||
      !this.changesMade()
    );
  }

  /**
   * Checks if email is a vixxo email
   * @param email string
   */
  private checkVixxoEmail(email: any): void {
    if (email) {
      this.isVixxoEmail =
        email.toLowerCase().indexOf('@vixxo.com') >= 0 ? true : false;
    }
  }

  /**
   * Only allow alphabetical characters
   * @param e character the user keypresses
   */
  protected alphaOnly(e) {
    const key = e.keyCode;
    return (key >= 65 && key <= 90) || (key >= 97 && key <= 122) || key === 32;
  }

  /**
   * Checks if email is a valid email
   * @param email string
   */
  private checkValidEmail(email) {
    let emailRegex = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    this.isValidEmail = emailRegex.test(email) ? true : false;
  }

  /**
   * Checks if vemail is too long for auth0 to save
   * @param email string
   */
  private checkLongEmail(email) {
    if (email.indexOf('@') > 0) {
      this.emailTooLong =
        email.split('@')[0].length > 64 || email.split('@')[1].length > 254
          ? true
          : false;
    }
  }

  /**
   * Checks if valid email, vixxo email, and long email
   * @param email string
   */
  protected emailValidations(email): void {
    this.checkLongEmail(email);
    this.checkVixxoEmail(email);
    this.checkValidEmail(email);
    if (this.isValidEmail && !this.emailTooLong && !this.isVixxoEmail) {
      this.validateAuth0EmailExists();
      this.federatedSSOMatch = matchExternalSSO(email || '');
    } else {
      this.isAuth0EmailExists = false;
      this.federatedSSOMatch = false;
    }
  }

  protected onStatusClicked(): void {
    if (this.statusSwitch === true) {
      this.statusActive = 'Active';
      this.user.status = 'Active';
      this.enableEditFields();
    } else {
      this.statusActive = 'Inactive';
      this.user.status = 'Deactivated';
      this.disableEditFields();
    }
  }

  /**
   * Validates the Email exists in Auth0
   * @param email: string
   */
  public validateAuth0EmailExists(): void {
    this.usersService
      .validateEmailExists(this.user.email.toLowerCase())
      .subscribe(
        (res: any) => {
          const userExists = !!(res && res.success && res.validateEmail);
          const metadataExists = !!(res && res.success && res.metadataExists);
          if (
            res.success &&
            this.title === SpNewUserComponent.SERVICEPROVIDEREDIT &&
            this.spUser.email.toLowerCase() === this.user.email.toLowerCase()
          ) {
            this.isAuth0EmailExists = false;
          } else if (!userExists) {
            this.isAuth0EmailExists = false;
          } else if (userExists && metadataExists) {
            this.isAuth0EmailExists = true;
          } else {
            this.isAuth0EmailExists = false;
          }
        },
        () => {
          this.onAPIError(
            'An error occurred while validating email already exist'
          );
          this.isAuth0EmailExists = false;
        }
      );
  }
}
